import {
  Directive,
  ElementRef,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import {
  AbstractControl,
  NgControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../companies/models/company-country-validations';
import { SessionService }              from '../../sessions/session.service';

@Directive({
  selector : '[worPhoneValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: PhoneValidator
    }
  ]
})
export class PhoneValidator implements OnInit, Validator {
  private _control           : NgControl = null;
  private _defaultValidation = '^\\d+$';
  private _validations       : CompanyCountryValidationsModel;

  mask : string;
  regex: RegExp;

  @Input ('isMobile') isMobile    ?: boolean;

  get validations (): CompanyCountryValidationsModel {
    return this._validations;
  }

  @Input() set validations ( _validations: CompanyCountryValidationsModel ) {
    this._validations = _validations;

    if (this._control) {
      setTimeout(() => this._control.control.updateValueAndValidity());
    }
  }

  @Input ('worPhoneValidator') value: string;

  constructor (
    private injector      : Injector,
    private element       : ElementRef<HTMLInputElement>,
    private sessionService: SessionService
  ) {}

  ngOnInit () : void {
    this._control = this.injector.get(NgControl);
  }

  getAndSetValidations () {
    const countryValidations = this.sessionService.countryValidation();
    let regex;

    if (this.validations) {
      this.mask = this.isMobile && this.validations.mobile?.mask
        ? this.validations.mobile.mask
        : this.validations.phone.mask;

      regex = this.isMobile && this.validations.mobile?.validation
        ? this.validations.mobile.validation
        : this.validations.phone.validation;
    }
    else {
      this.mask = this.isMobile && countryValidations.mobile?.mask
        ? countryValidations.mobile.mask
        : countryValidations.phone.mask;

      regex = this.isMobile && countryValidations.mobile?.validation
        ? countryValidations.mobile.validation
        : countryValidations.phone.validation;
    }

    this.regex = new RegExp(regex || this._defaultValidation);
  }

  validate ( ctrl: AbstractControl ) : { [ key: string ] : any } {
    this.getAndSetValidations();

    if (!ctrl.value) {
      return null;
    }

    if (ctrl.value.match(this.regex)) {
      if (this.mask) {
        this.element.nativeElement.value = ctrl.value.replace(this.regex, this.mask);
      }

      return null;
    }

    return { phone: true };
  }
}